import { createSelector, createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import * as fromAuth from './auth.reducer';
import { AuthModuleState } from '../';

const selectAuthModuleState = createFeatureSelector<AuthModuleState>('authentication');

const selectAuthState = createSelector(selectAuthModuleState, (state: AuthModuleState) => state?.auth);

export const selectToken = createSelector(selectAuthState, fromAuth.getToken);

export const selectConnection = createSelector(selectAuthState, fromAuth.getCurrentConnection);

export const selectError = createSelector(selectAuthState, fromAuth.getError);

export const selectIsWorking = createSelector(selectAuthState, fromAuth.getIsWorking);

export const selectShowPassword = createSelector(selectAuthState, fromAuth.getShowPassword);

export const selectIsCompletingLogin = createSelector(selectAuthState, fromAuth.getIsCompletingLogin);

export const selectUsername = createSelector(selectAuthState, fromAuth.getUsername);

export const selectUserContext = createSelector(selectAuthState, fromAuth.getUserContext);

export const selectIsExpired = createSelector(selectAuthState, fromAuth.getIsExpired);

export const selectIsSharedMapWorking = createSelector(selectAuthState, fromAuth.getSharedMapIsWorking);

export const selectMapLinkError = createSelector(selectAuthState, fromAuth.getMapLinkError);

export const selectIsSharedDashboardWorking = createSelector(selectAuthState, fromAuth.getSharedDashboardIsWorking);

export const selectDashboardLinkError = createSelector(selectAuthState, fromAuth.getDashboardLinkError);

export const selectLanguages = createSelector(selectAuthState, fromAuth.getLanguages);

export const selectIsExternalLinkAuthWorking = createSelector(selectAuthState, fromAuth.getExternalLinkIsWorking);

export const selectExternalLinkError = createSelector(selectAuthState, fromAuth.getExternalLinkLinkError);

export const selectPermissionsChangeTime = createSelector(selectAuthState, fromAuth.getPermissionsChangeTime);

export const selectShowAcceptancePage = createSelector(selectAuthState, fromAuth.getShowAcceptancePage);
export const selectShowBusinessUnitsWarning = createSelector(selectAuthState, fromAuth.getShowBusinessUnitsWarning);
export const selectBusinessUnitsWarningAccepted = createSelector(selectAuthState, fromAuth.getBusinessUnitsWarningAccepted);

